var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M0 15.9995C0 24.8361 7.16344 31.9995 16 31.9995C24.8366 31.9995 32 24.8361 32 15.9995C32 7.16296 24.8366 -0.000488281 16 -0.000488281C7.16344 -0.000488281 0 7.16296 0 15.9995Z",
    fill: "#2867B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "linkedin_2",
    d: "M11.6 23.9995H8.2V13.2995H11.6V23.9995ZM9.9 11.7995C8.8 11.7995 8 10.9995 8 9.89951C8 8.79951 8.9 7.99951 9.9 7.99951C11 7.99951 11.8 8.79951 11.8 9.89951C11.8 10.9995 11 11.7995 9.9 11.7995ZM24 23.9995H20.6V18.1995C20.6 16.4995 19.9 15.9995 18.9 15.9995C17.9 15.9995 16.9 16.7995 16.9 18.2995V23.9995H13.5V13.2995H16.7V14.7995C17 14.0995 18.2 12.9995 19.9 12.9995C21.8 12.9995 23.8 14.0995 23.8 17.3995V23.9995H24Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5bda4465fa48c6473d6585634c35e398.svg";
export { ForwardRef as ReactComponent };